@if (open) {
  <div
    #overlay
    class="overlay"
    [class.overlay-appear]="justOpened"
    [class.is-drawer]="placement === 'right-drawer'"
    [style.--op-backdrop-filter]="backdropFilter"
    [style.--op-backdrop-surface]="backdropSurface"
    [style.--op-backdrop-glow]="backdropGlow"
  >
    <div class="overlay-backdrop" (pointerdown)="onBackdrop($event)"></div>
    <div
      #panel
      class="panel"
      [class.layout-pending]="!layoutReady"
      [class.dragging]="dragging"
      [class.is-dialog]="variant === 'dialog'"
      [class.is-drawer]="placement === 'right-drawer'"
      [class.compact]="dense"
      [class.appear]="justOpened"
      [class.anim-slide]="selectedAnim === 'slide'"
      [class.anim-scale]="selectedAnim === 'scale'"
      [class.anim-morph]="selectedAnim === 'morph'"
      [ngClass]="panelClass"
      [style.left.px]="pos.left"
      [style.top.px]="pos.top"
      [style.width.px]="size.w"
      [style.height.px]="size.h"
      [style.minWidth.px]="panelMinWidth"
      [style.minHeight.px]="panelMinHeight"
      [style.maxWidth.px]="placement === 'right-drawer' ? null : maxWidth"
      [style.maxHeight.px]="placement === 'right-drawer' ? null : maxHeight"
      [style.transform]="dragTransform"
      (pointerdown)="onPanelPointerDown($event)"
      style="pointer-events: auto"
    >
      @if (showHeader) {
        <div
          #dragHandle
          class="modal-hdr"
          [class.compact]="dense"
          (pointerdown)="onHeaderPointerDown($event)"
        >
          <div class="ttl">
            @if (titleIcon ? titleOverlayIcons[titleIcon] : null; as icon) {
              <span class="title-icon" aria-hidden="true">
                <hugeicons-icon [icon]="icon" [size]="18" [strokeWidth]="1.9"></hugeicons-icon>
              </span>
            }
            <span class="ttl-text">
              <span class="title">{{ title }}</span>
              @if (subtitle) {
                <span class="subtitle">{{ subtitle }}</span>
              }
            </span>
          </div>
          <div class="hdr-actions">
            @if (showHeaderAction && headerActionLabel) {
              <button
                type="button"
                class="header-action"
                [attr.title]="headerActionTitle || headerActionLabel"
                (click)="headerAction.emit()"
              >
                @if (headerActionIcon) {
                  <i [appIcon]="headerActionIcon" aria-hidden="true"></i>
                }
                <span>{{ headerActionLabel }}</span>
              </button>
            }
            <ng-content select="[panel-actions]"></ng-content>
            @if (showSave) {
              <button
                type="button"
                class="icon square"
                [class.accent]="saveAccent"
                (click)="save.emit()"
              >
                <hugeicons-icon
                  [icon]="saveOverlayIcon"
                  [size]="16"
                  [strokeWidth]="1.9"
                  aria-hidden="true"
                ></hugeicons-icon>
              </button>
            }
            @if (showDelete) {
              <button type="button" class="icon square danger" (click)="delete.emit()">
                <hugeicons-icon
                  [icon]="deleteOverlayIcon"
                  [size]="16"
                  [strokeWidth]="1.9"
                  aria-hidden="true"
                ></hugeicons-icon>
              </button>
            }
            <button
              type="button"
              class="icon square"
              [class.danger]="closeDanger"
              [class.ghost]="!closeDanger"
              (pointerdown)="onClosePointerDown($event)"
              (click)="onCloseClick($event)"
            >
              <hugeicons-icon
                [icon]="closeOverlayIcon"
                [size]="16"
                [strokeWidth]="1.9"
                aria-hidden="true"
              ></hugeicons-icon>
            </button>
          </div>
        </div>
      }
      <div
        class="body"
        [class.compact]="dense"
        [style.padding.px]="dense ? bodyPaddingDense : bodyPadding"
      >
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
